// extracted by mini-css-extract-plugin
export default {"items":"menu-module__items--zGF2n","itemHidden":"menu-module__itemHidden--_Zc45"};